import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent, Children, cloneElement } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withStyles } from '../theme';
import { isolateMixin } from '../utils/mixins';

var styles = function styles(theme) {
  return {
    root: {
      extend: isolateMixin,
      position: 'relative',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'stretch',
      '& > *': {
        flex: 1,
        flexBasis: 0
      },
      '& input': {
        '&, &:disabled, &:enabled:hover': {
          borderColor: 'transparent',
          backgroundColor: 'transparent'
        },
        '&:enabled:focus': {
          backgroundColor: 'transparent'
        }
      },
      '& > :nth-child(n+2)': {
        marginLeft: -1
      },
      '&:before': {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        border: '0 solid',
        borderColor: theme.field.colors.default.outline,
        content: '""',
        transition: "all ".concat(theme.field.animationDuration, "ms ease")
      },
      '&:not($disabled):hover:before': {
        borderColor: theme.field.colors.hover.outline
      }
    },
    disabled: {
      '&:before': {
        borderColor: theme.field.colors.disabled.outline
      }
    },
    regular: {
      backgroundColor: theme.field.colors.default.background,
      '&$disabled': {
        backgroundColor: theme.field.colors.disabled.background
      },
      '&:before': {
        borderRadius: theme.field.borderRadius,
        borderWidth: 1
      }
    },
    awesome: {
      composes: ['$regular']
    },
    promo: {
      '&:before': {
        paddingTop: 1,
        borderBottomWidth: 1
      }
    },
    showDivider: {
      '& > :not(:last-child) input': {
        borderRightColor: theme.field.colors.default.outline
      },
      '&:hover > :not(:last-child) input': {
        borderRightColor: theme.field.colors.hover.outline
      }
    }
  };
};

var FieldGroup = /*#__PURE__*/function (_PureComponent) {
  _inherits(FieldGroup, _PureComponent);

  var _super = _createSuper(FieldGroup);

  function FieldGroup() {
    _classCallCheck(this, FieldGroup);

    return _super.apply(this, arguments);
  }

  _createClass(FieldGroup, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          style = _this$props.style,
          classes = _this$props.classes,
          children = _this$props.children,
          disabled = _this$props.disabled,
          size = _this$props.size,
          variation = _this$props.variation,
          status = _this$props.status,
          showDivider = _this$props.showDivider;
      var count = Children.count(children);
      var i = 1;
      return React.createElement("div", {
        style: style,
        className: classnames(className, classes.root, classes[variation], disabled && classes.disabled, showDivider && classes.showDivider)
      }, Children.map(children, function (child) {
        if (!child) return;
        var groupPosition = 'middle';
        if (i === 1) groupPosition = 'start';else if (i === count) groupPosition = 'end';
        i++;
        return cloneElement(child, {
          disabled: disabled,
          size: size,
          variation: variation,
          status: status,
          groupPosition: groupPosition
        });
      }));
    }
  }]);

  return FieldGroup;
}(PureComponent);

FieldGroup.defaultProps = {
  variation: 'awesome',
  showDivider: false
};
FieldGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Класс контейнера
   */
  className: PropTypes.string,

  /**
   * Переопределение стилей контейнера
   */
  style: PropTypes.object,

  /**
   * Размер инпутов группы
   */
  size: PropTypes.oneOf(['small', 'medium']),

  /**
   * Разновидность инпутов группы
   */
  variation: PropTypes.oneOf(['regular', 'awesome', 'promo']),

  /**
   * Статус валидации инпутов группы
   */
  status: PropTypes.oneOf(['error', 'warning', 'success', null]),

  /**
   * Доступность инпутов группы
   */
  disabled: PropTypes.bool,

  /**
   * Разделитель между инпутами группы
   */
  showDivider: PropTypes.bool,

  /**
   * Набор полей ввода Input или Select
   */
  children: PropTypes.node.isRequired
} : {};
export default withStyles(styles, {
  name: 'FieldGroup'
})(FieldGroup);